/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC, ReactElement } from "react";

import { Icon, Text } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";

import { UILuggageAllowance, UILuggageCheckedWeightBasedAllowance } from "@flights/types";
import FlightDetailsAncillaryItemLayout from "../../FlightDetailsAncillaryItemLayout";
import { includedBaggageIcons } from "@flights/branded-fares";
import { SPACER_PADDED } from "@flights/constants";
import { formattingUtils } from "@flights/web-api-utils-universal";
import useRouteName from "../../../../hooks/useRouteName";
import useProfiler from "../../../../hooks/useProfiler";
import flights_web_condensed_extras_fd_mdot from "../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

export const BaggageItem: FC<{
  luggage: UILuggageAllowance;
  subtitle?: ReactElement;
  hideIncludedSection?: boolean;
  footer?: any;
  alignIconCenter?: boolean;
  extraTestId?: string;
  /* start - flights_web_remove_baggage_weight_size_fd */
  showRestrictions?: boolean;
  /* end - flights_web_remove_baggage_weight_size_fd */
}> = ({
  luggage,
  subtitle = null,
  hideIncludedSection = false,
  footer = null,
  alignIconCenter = false,
  extraTestId,
  showRestrictions = true
}) => {
  const i18n = useI18n();

  const IconSVG = includedBaggageIcons[luggage.luggageType];
  const {
    title: defaultTitle,
    size,
    weightPerPiece,
    totalWeight
  } = formattingUtils.luggageAllowanceCopyV2(luggage, i18n);
  const restrictions = [size, totalWeight, weightPerPiece].filter(Boolean);

  const routeName = useRouteName();
  const { isMobile } = useProfiler();
  const condensedFDMobile =
    routeName == "flightdetails" && isMobile() && !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  const isWeightBasedWithContent = (
    allowance: UILuggageAllowance
  ): allowance is UILuggageCheckedWeightBasedAllowance & {
    content: { title?: string; subtitle?: ReactElement | string };
  } => {
    return (
      allowance.luggageType === "CHECKED_IN" &&
      "ruleType" in allowance &&
      allowance.ruleType === "WEIGHT_BASED" &&
      "content" in allowance &&
      !!allowance.content
    );
  };

  let title = defaultTitle;
  let subtitleToUse = subtitle;
  let extraInfo = null;
  if (isWeightBasedWithContent(luggage)) {
    title = luggage.content.titleCondensed || defaultTitle;
    extraInfo = luggage.content.extraInfo;
    if (luggage.content.subtitle) {
      if (typeof luggage.content.subtitle === "string") {
        subtitleToUse = <Text variant="body_2">{luggage.content.subtitle}</Text>;
      } else {
        subtitleToUse = luggage.content.subtitle;
      }
    }
  }

  const description = extraInfo || (restrictions.length > 0 ? restrictions.join(SPACER_PADDED) : null);
  return (
    <FlightDetailsAncillaryItemLayout
      icon={<Icon svg={IconSVG} size={condensedFDMobile ? "medium" : "large"} />}
      content={
        <>
          <Text attributes={{ "data-testid": "baggage_title" }} variant="body_2">
            {title}
          </Text>
          {subtitleToUse}
          {showRestrictions
            ? description && (
                <Text attributes={{ "data-testid": "baggage_description" }} variant="body_2">
                  {description}
                </Text>
              )
            : undefined}
          {footer}
        </>
      }
      includedBaggage={true}
      hideIncludedSection={hideIncludedSection}
      alignIconCenter={alignIconCenter}
      extraTestId={extraTestId}
    />
  );
};
